import forEach from "./forEach"

/**
 * Helper to paypal seamless transactions
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/* global paypal */
/* disable camelcase */

export default class Paypal {
  init (amount, action, shipping, items) {
    if (typeof paypal === 'undefined') {
      return false
    }

    this.amount = amount
    this.action = action
    this.shipping = shipping
    this.items = items

    const createOrder = (data, actions) => this.createOrder(actions.order)
    const onApprove = (data, actions) => this.finish(data.orderID, actions.order)

    paypal
      .Buttons({ createOrder, onApprove })
      .render('#paypal-button-container')
  }

  createOrder (order) {
    /* eslint-disable */
    var itemsArray = [];
    var sumOfProducts = 0;
    forEach(this.items, (i, el) => {
      var itemPrice = Math.round((el.price * el.qty) * 100) / 100

      itemsArray.push(
        {
          name: el.name + " QTY: " + el.qty,
          unit_amount: {value: itemPrice, currency_code: 'EUR'},
          quantity: "1"
        }
      )
      sumOfProducts = Math.round((sumOfProducts + itemPrice) * 100) / 100;
    })
    if(this.shipping > 0) {
      itemsArray.push(
        {
          name: App.lang.$t('confirm.delivery'),
          unit_amount: {value: this.shipping, currency_code: 'EUR'},
          quantity: "1"
        }
      )
      sumOfProducts = sumOfProducts + this.shipping
    }
    
    var difference = Math.round((this.amount - sumOfProducts) * 100) / 100;

    if(difference < 0) {
      for(let i=0; i<itemsArray.length; i++) {
        if(Math.round((itemsArray[i].unit_amount.value) * 100) /100 >= difference*-1) {
          itemsArray[i].unit_amount.value = Math.round((itemsArray[i].unit_amount.value + difference) * 100) /100;
          break;
        } else {
          difference = Math.round((difference + itemsArray[i].unit_amount.value) * 100) /100;
          itemsArray[i].unit_amount.value = 0;
        }
      }
    }
    
    return order.create({
      style: {
        color: 'white',
        shape: 'rect',
        layout: 'horizontal'
      },
      purchase_units: [{
        amount: {
          value: this.amount,
          currency_code: 'EUR',
          breakdown: {
            item_total: {value: this.amount, currency_code: 'EUR'}
          }
        },
        items: itemsArray
      }]
    })
    /* eslint-enable */
  }

  finish (id, order) {
    return order.capture().then((details) => {
      const form = document.createElement('form')
      const input = document.createElement('input')
      form.appendChild(input)

      form.action = this.action
      form.method = 'post'
      input.type = 'hidden'
      input.name = 'orderID'
      input.value = id

      document.body.appendChild(form)
      this.amount = null
      form.submit()
    })
  }
}
